// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1931":"fa2d64cfeb979393ee1d","3911":"2592e28b63e779de6bff","5348":"511b473b8c1e4a717d91","8361":"7ad6799aa556f2838abe","9471":"c8424785a63696ff56fc"}[chunkId] + ".css";
};